import React, { useState, useEffect } from "react";
import StaticPageService from '../../services/StaticPageService';
import useAuth from "../../hooks/useAuth";
import GearSpinner from "../../components/GearSpinner/GearSpinner";
import { SITE_TITLE } from '../../utils/constants';
import { seo } from '../../utils/seo';


const StaticPage = () => {
    const { user } = useAuth();
    const [ data, setData ] = useState([]);
    const [ showLoader, setShowLoader ] = useState(true);
    
    const renderHTML = (rawHTML) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
    const staticPageService = new StaticPageService();
    const title = 'CSR Open Orders';
    
    useEffect(() => {
        seo({
            title: SITE_TITLE + ' || '+title,
            metaDescription: '',
        });
        getStaticPage()

    }, [user]);

    const getStaticPage = () => {
        const permalink = 'csr-open-orders'
        staticPageService.getStaticPage(permalink).then((response) => {
            const dataResponse = response.data
            if(dataResponse.response === 'success') {
                setData(dataResponse.result.static_page[0].fields)
            }
        }).finally(() => {
            setShowLoader(false);
        });
    }

    const renderNoData = () => {
        return (
            <div class="text-center my-5 fade-in">
                <div class="p-5 rounded-3 shadow-sm bg-light border mx-5">
                    <h3 class="fw-bold text-dark">Data not found.</h3>
                    
                </div>
            </div>
        )
    }

    return (
        <React.Fragment>
            <main className="techtop-middle-div">
				<section className="techtop-news-section pb-5">
					<div className="container">
						{/* Page Title */}
						<div className="row">
							<div className="col-md-12">
								<div className="techtop-default-title2">
									<div className="row">
										<div className="col-md-6">
											<h1 className="m-0 dark-color1">{title}</h1>
										</div>
										<div className="col-md-6 text-end">
											<h1 className="m-0 dark-color1">{user.name}</h1>
										</div>
									</div>
								</div>
                                <div className="row">													 
                                    <div className="col-md-12 mt-3">
                                        {showLoader && (
                                            <GearSpinner />
                                        )}
                                        {(!showLoader && !data?.content) && renderNoData() }
                                        {data?.content && (
                                            renderHTML(data.content)
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </React.Fragment>
    )
}

export default StaticPage;